const getters = {
    bankData: state => state.bankData
};

export default getters;